module.exports = __webpack_public_path__ + "img/baota.6022bf8.png";